module.exports = __webpack_public_path__ + "static/media/paw-alt.4c34443b.svg";